import React from 'react';
import FileTextIcon from '../../icons/IconLib/FileTextIcon';
import OptionSelect, { IOption } from './OptionSelect';

/** Форматы стикера муштаха — список фиксированный на стороне принтера. */
export const PALLET_FORMAT_OPTIONS: IOption[] = [
    { value: 1, label: '10X15 עם פירוט' },
    { value: 2, label: '15X10 ללא פירוט' },
    { value: 3, label: '10X10 ללא פירוט' },
    { value: 4, label: '6x9 ללא פירוט' },
];

/** Форматы стикера книсы. */
export const ENTRY_FORMAT_OPTIONS: IOption[] = [
    { value: 1, label: '10X15' },
    { value: 2, label: '10X10' },
];

interface Props {
    options: IOption[];
    value: number | null;
    onSelect: (value: number) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    className?: string;
}

const PrintFormatSelector: React.FC<Props> = ({
    options,
    value,
    onSelect,
    placeholder = 'בחר פורמט',
    disabled,
    readOnly,
    leadingIcon,
    className,
}) => (
    <OptionSelect
        options={options}
        value={options.find((o) => o.value === value) ?? null}
        onSelect={(o) => onSelect(o?.value ?? 0)}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={leadingIcon === undefined ? <FileTextIcon /> : leadingIcon}
        className={className}
    />
);

export default PrintFormatSelector;
